var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7437 3.00006C10.402 2.65835 9.84799 2.65835 9.50628 3.00006L4.50628 8.00006L9.50628 13.0001C9.84799 13.3418 10.402 13.3418 10.7437 13.0001C11.0854 12.6583 11.0854 12.1043 10.7437 11.7626L6.98115 8.00006L10.7437 4.23749C11.0854 3.89578 11.0854 3.34176 10.7437 3.00006Z",
    fill: "#7075E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.b46ac92f79a16f38d10753c78761db4e.svg";
export { ForwardRef as ReactComponent };